/* unplugin-vue-components disabled */import { render } from "./track-person.vue?vue&type=template&id=2be2afc8&scoped=true"
import script from "./track-person.vue?vue&type=script&lang=js"
export * from "./track-person.vue?vue&type=script&lang=js"

import "./track-person.vue?vue&type=style&index=0&id=2be2afc8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be2afc8"],['__file',"src/pages/pulse/tracker/track-person.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2be2afc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2be2afc8', __exports__)) {
    api.reload('2be2afc8', __exports__)
  }
  
  module.hot.accept("./track-person.vue?vue&type=template&id=2be2afc8&scoped=true", () => {
    api.rerender('2be2afc8', render)
  })

}


export default __exports__